// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avatar_0c914f24 {
  display: block;
}
.avatar_0c914f24 img {
  height: auto;
  flex-shrink: 0;
  object-fit: cover;
}
.avatar_0c914f24[type="button"] {
  padding: 0;
  border: none;
  background-color: transparent;
}
.avatar__box_0c914f24 {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
  color: #657682;
  border-radius: inherit;
}
.avatar__centered_0c914f24 {
  position: absolute;
  top: 50%;
  left: 51%;
  transform: translate(-50%, -50%);
}
.avatar_bg_0c914f24 .avatar__box_0c914f24 {
  background-color: #f8f9fa;
}
.avatar_x-small_0c914f24 {
  width: 1.5rem;
  min-width: 1.5rem;
  height: 1.5rem;
  font-size: 1rem;
}
.avatar_x-small_0c914f24 img {
  max-height: 1.5rem;
  max-width: 1.5rem;
}
.avatar_small_0c914f24 {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
  font-size: 1.334rem;
}
.avatar_small_0c914f24 img {
  max-height: 2rem;
  max-width: 2rem;
}
.avatar_medium_0c914f24 {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
  font-size: 1.667rem;
}
.avatar_medium_0c914f24 img {
  max-height: 2.667rem;
  max-width: 2.667rem;
}
.avatar_normal_0c914f24 {
  width: 3rem;
  min-width: 3rem;
  height: 3rem;
  font-size: 2rem;
}
.avatar_normal_0c914f24 img {
  max-height: 3rem;
  max-width: 3rem;
}
.avatar_large_0c914f24 {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  font-size: 2.667rem;
}
.avatar_large_0c914f24 img {
  max-height: 4rem;
  max-width: 4rem;
}
.avatar_large_0c914f24 .avatar__box_0c914f24 {
  border-width: 0.167rem;
}
.avatar_x-large_0c914f24 {
  width: 4.667rem;
  min-width: 4.667rem;
  height: 4.667rem;
  font-size: 3rem;
}
.avatar_x-large_0c914f24 img {
  max-height: 4.667rem;
  max-width: 4.667rem;
}
.avatar_x-large_0c914f24 .avatar__box_0c914f24 {
  border-width: 0.167rem;
}
.avatar_xx-large_0c914f24 {
  width: 6rem;
  min-width: 6rem;
  height: 6rem;
  font-size: 4rem;
}
.avatar_xx-large_0c914f24 img {
  max-height: 6rem;
  max-width: 6rem;
}
.avatar_xx-large_0c914f24 .avatar__box_0c914f24 {
  border-width: 0.167rem;
}
.avatar_rounded_0c914f24 {
  border-radius: 50%;
}
.avatar_square_0c914f24 {
  border: none;
}
.avatar_border_0c914f24 {
  border: 0.084rem solid #dce1e5;
  background-color: #fff;
}
.avatar_fav-icon-xxs_0c914f24 {
  width: 0.167rem;
  min-width: 0.167rem;
  height: 0.167rem;
}
.avatar_fav-icon-xxs_0c914f24 img {
  max-height: 0.167rem;
  max-width: 0.167rem;
}
.avatar_fav-icon-xs_0c914f24 {
  width: 0.334rem;
  min-width: 0.334rem;
  height: 0.334rem;
}
.avatar_fav-icon-xs_0c914f24 img {
  max-height: 0.334rem;
  max-width: 0.334rem;
}
.avatar_fav-icon-s_0c914f24 {
  width: 0.667rem;
  min-width: 0.667rem;
  height: 0.667rem;
}
.avatar_fav-icon-s_0c914f24 img {
  max-height: 0.667rem;
  max-width: 0.667rem;
}
.avatar_fav-icon-sm_0c914f24 {
  width: 1rem;
  min-width: 1rem;
  height: 1rem;
}
.avatar_fav-icon-sm_0c914f24 img {
  max-height: 1rem;
  max-width: 1rem;
}
.avatar_fav-icon-m_0c914f24 {
  width: 1.334rem;
  min-width: 1.334rem;
  height: 1.334rem;
}
.avatar_fav-icon-m_0c914f24 img {
  max-height: 1.334rem;
  max-width: 1.334rem;
}
.avatar_fav-icon-l_0c914f24 {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
}
.avatar_fav-icon-l_0c914f24 img {
  max-height: 2rem;
  max-width: 2rem;
}
.avatar_fav-icon-xl_0c914f24 {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.avatar_fav-icon-xl_0c914f24 img {
  max-height: 2.667rem;
  max-width: 2.667rem;
}
.avatar_fav-icon-xls_0c914f24 {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
}
.avatar_fav-icon-xls_0c914f24 img {
  max-height: 4rem;
  max-width: 4rem;
}
.avatar_fav-icon-xxl_0c914f24 {
  width: 5.334rem;
  min-width: 5.334rem;
  height: 5.334rem;
}
.avatar_fav-icon-xxl_0c914f24 img {
  max-height: 5.334rem;
  max-width: 5.334rem;
}
.avatar_fav-icon-xxxl_0c914f24 {
  width: 10.667rem;
  min-width: 10.667rem;
  height: 10.667rem;
}
.avatar_fav-icon-xxxl_0c914f24 img {
  max-height: 10.667rem;
  max-width: 10.667rem;
}
.avatar__person_0c914f24 .avatar__box_0c914f24 {
  font-size: 3rem;
}
.avatar__person_0c914f24.avatar_x-small_0c914f24 .avatar__box_0c914f24 {
  font-size: 17px;
}
.avatar__person_0c914f24.avatar_small_0c914f24 .avatar__box_0c914f24 {
  font-size: 22px;
}
.avatar__person_0c914f24.avatar_medium_0c914f24 .avatar__box_0c914f24 {
  font-size: 30px;
}
.avatar__person_0c914f24.avatar_large_0c914f24 .avatar__box_0c914f24 {
  font-size: 46px;
}
.avatar__person_0c914f24.avatar_x-large_0c914f24 .avatar__box_0c914f24 {
  font-size: 54px;
}
.avatar__person_0c914f24.avatar_xx-large_0c914f24 .avatar__box_0c914f24 {
  font-size: 70px;
}
.avatar__initials_0c914f24 .avatar__box_0c914f24 {
  font-size: 1rem;
  line-height: 1;
}
.avatar__initials_color-blue_0c914f24 .avatar__box_0c914f24 {
  color: #1d5080;
  border-color: #1d5080;
}
.avatar__initials_color-green_0c914f24 .avatar__box_0c914f24 {
  color: #40c2c9;
  border-color: #40c2c9;
}
.avatar__initials_color-skyBlue_0c914f24 .avatar__box_0c914f24 {
  color: #267479;
  border-color: #267479;
}
.avatar__initials_color-lightBlue_0c914f24 .avatar__box_0c914f24 {
  color: #f5c914;
  border-color: #f5c914;
}
.avatar__initials_color-yellow_0c914f24 .avatar__box_0c914f24 {
  color: #a26426;
  border-color: #a26426;
}
.avatar__initials_color-aqua_0c914f24 .avatar__box_0c914f24 {
  color: #0f345c;
  border-color: #0f345c;
}
.avatar__initials_color-tropicalForest_0c914f24 .avatar__box_0c914f24 {
  color: #78766f;
  border-color: #78766f;
}
.avatar__initials_color-plum_0c914f24 .avatar__box_0c914f24 {
  color: #c0bcb2;
  border-color: #c0bcb2;
}
.avatar__initials_color-orange_0c914f24 .avatar__box_0c914f24 {
  color: #e88f36;
  border-color: #e88f36;
}
.avatar__initials_color-gray_0c914f24 .avatar__box_0c914f24 {
  color: #1a4f52;
  border-color: #1a4f52;
}
.avatar__initials_color-plumDark_0c914f24 .avatar__box_0c914f24 {
  color: #c4a110;
  border-color: #c4a110;
}
.avatar__initials_color-yellowLight_0c914f24 .avatar__box_0c914f24 {
  color: #6185a6;
  border-color: #6185a6;
}
.avatar__initials_color-grayDark_0c914f24 .avatar__box_0c914f24 {
  color: #bbcbd9;
  border-color: #bbcbd9;
}
.avatar__initials_color-darkOrangeDark_0c914f24 .avatar__box_0c914f24 {
  color: #657682;
  border-color: #657682;
}
.avatar__initials_0c914f24.avatar_x-small_0c914f24 .avatar__box_0c914f24 {
  font-size: 6px;
}
.avatar__initials_0c914f24.avatar_small_0c914f24 .avatar__box_0c914f24 {
  font-size: 8px;
}
.avatar__initials_0c914f24.avatar_medium_0c914f24 .avatar__box_0c914f24 {
  font-size: 12px;
}
.avatar__initials_0c914f24.avatar_large_0c914f24 .avatar__box_0c914f24 {
  font-size: 18px;
}
.avatar__initials_0c914f24.avatar_x-large_0c914f24 .avatar__box_0c914f24 {
  font-size: 20px;
}
.avatar__initials_0c914f24.avatar_xx-large_0c914f24 .avatar__box_0c914f24 {
  font-size: 26px;
}
.avatar-group_0c914f24 {
  justify-content: flex-end;
  flex-direction: row-reverse;
}
.avatar-group_0c914f24.element-group .element-group__item:not(:first-child) {
  margin-right: -0.333rem;
}
.avatar-group__item_0c914f24.avatar .avatar__box {
  color: #657682;
  border-color: #dce1e5;
  background-color: #f8f9fa;
}
.avatar-group__item_active_0c914f24.avatar .avatar__box {
  color: #6185a6;
  border-color: #6185a6;
  background-color: #fff;
  box-shadow: 0 0 0 0.167rem #dceffa;
}
.avatar-group__counter_0c914f24.avatar.avatar_x-small .avatar__box {
  font-size: 0.667rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_small .avatar__box {
  font-size: 0.834rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_medium .avatar__box {
  font-size: 1.167rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_normal .avatar__box {
  font-size: 1.334rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_large .avatar__box {
  font-size: 1.75rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_x-large .avatar__box {
  font-size: 2.084rem;
}
.avatar-group__counter_0c914f24.avatar.avatar_xx-large .avatar__box {
  font-size: 2.667rem;
}
.avatar-group__counter_0c914f24.avatar .avatar__box {
  font-weight: 600;
  color: #11304d;
  background-color: #dce1e5;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `avatar_0c914f24`,
	"avatar__box": `avatar__box_0c914f24`,
	"avatar__centered": `avatar__centered_0c914f24`,
	"avatar_bg": `avatar_bg_0c914f24`,
	"avatar_x-small": `avatar_x-small_0c914f24`,
	"avatar_small": `avatar_small_0c914f24`,
	"avatar_medium": `avatar_medium_0c914f24`,
	"avatar_normal": `avatar_normal_0c914f24`,
	"avatar_large": `avatar_large_0c914f24`,
	"avatar_x-large": `avatar_x-large_0c914f24`,
	"avatar_xx-large": `avatar_xx-large_0c914f24`,
	"avatar_rounded": `avatar_rounded_0c914f24`,
	"avatar_square": `avatar_square_0c914f24`,
	"avatar_border": `avatar_border_0c914f24`,
	"avatar_fav-icon-xxs": `avatar_fav-icon-xxs_0c914f24`,
	"avatar_fav-icon-xs": `avatar_fav-icon-xs_0c914f24`,
	"avatar_fav-icon-s": `avatar_fav-icon-s_0c914f24`,
	"avatar_fav-icon-sm": `avatar_fav-icon-sm_0c914f24`,
	"avatar_fav-icon-m": `avatar_fav-icon-m_0c914f24`,
	"avatar_fav-icon-l": `avatar_fav-icon-l_0c914f24`,
	"avatar_fav-icon-xl": `avatar_fav-icon-xl_0c914f24`,
	"avatar_fav-icon-xls": `avatar_fav-icon-xls_0c914f24`,
	"avatar_fav-icon-xxl": `avatar_fav-icon-xxl_0c914f24`,
	"avatar_fav-icon-xxxl": `avatar_fav-icon-xxxl_0c914f24`,
	"avatar__person": `avatar__person_0c914f24`,
	"avatar__initials": `avatar__initials_0c914f24`,
	"avatar__initials_color-blue": `avatar__initials_color-blue_0c914f24`,
	"avatar__initials_color-green": `avatar__initials_color-green_0c914f24`,
	"avatar__initials_color-skyBlue": `avatar__initials_color-skyBlue_0c914f24`,
	"avatar__initials_color-lightBlue": `avatar__initials_color-lightBlue_0c914f24`,
	"avatar__initials_color-yellow": `avatar__initials_color-yellow_0c914f24`,
	"avatar__initials_color-aqua": `avatar__initials_color-aqua_0c914f24`,
	"avatar__initials_color-tropicalForest": `avatar__initials_color-tropicalForest_0c914f24`,
	"avatar__initials_color-plum": `avatar__initials_color-plum_0c914f24`,
	"avatar__initials_color-orange": `avatar__initials_color-orange_0c914f24`,
	"avatar__initials_color-gray": `avatar__initials_color-gray_0c914f24`,
	"avatar__initials_color-plumDark": `avatar__initials_color-plumDark_0c914f24`,
	"avatar__initials_color-yellowLight": `avatar__initials_color-yellowLight_0c914f24`,
	"avatar__initials_color-grayDark": `avatar__initials_color-grayDark_0c914f24`,
	"avatar__initials_color-darkOrangeDark": `avatar__initials_color-darkOrangeDark_0c914f24`,
	"avatar-group": `avatar-group_0c914f24`,
	"avatar-group__item": `avatar-group__item_0c914f24`,
	"avatar-group__item_active": `avatar-group__item_active_0c914f24`,
	"avatar-group__counter": `avatar-group__counter_0c914f24`
};
export default ___CSS_LOADER_EXPORT___;
